import { FC } from 'react';
import { CatButton } from '@blocks-react/components/Button';
import { CatTooltip } from '@blocks-react/components/Tooltip';
import { CatIconFilterFilled } from '@blocks-react/components/Icons/FilterFilled';
import { CatIconFilterLines } from '@blocks-react/components/Icons/FilterLines';
import { CatTextPassage } from '@blocks-react/components/TextPassage';
import { FilterTooltipButtonProps } from '../types';

export const FilterTooltipButton: FC<FilterTooltipButtonProps> = ({
  handleEventClose,
  isNotificationError,
  isNoNotification,
  isFilterApplied,
  handleFilterDrawer,
  tooltipText,
}) => {
  return (
    <CatTooltip onBlTooltipClose={handleEventClose}>
      <>
        <CatButton
          slot="trigger"
          variant="ghost"
          hideText={true}
          data-testid="notifications-filters-button"
          disabled={
            (isNotificationError || isNoNotification) && !isFilterApplied
          }
          {...handleFilterDrawer}
        >
          
          {isFilterApplied ? (
            <CatIconFilterFilled
              slot="after"
              data-testid="filled-filter-button"
              aria-label={tooltipText}
            />
          ) : (
            <CatIconFilterLines
              slot="after"
              data-testid="filter-button"
              aria-label={tooltipText}
            />
          )}
        </CatButton>
        <CatTextPassage size="xs">{tooltipText}</CatTextPassage>
      </>
    </CatTooltip>
  );
};
